import { render, staticRenderFns } from "./MachineSetup.vue?vue&type=template&id=5ede0836&scoped=true"
import script from "./MachineSetup.vue?vue&type=script&lang=js"
export * from "./MachineSetup.vue?vue&type=script&lang=js"
import style0 from "./MachineSetup.vue?vue&type=style&index=0&id=5ede0836&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede0836",
  null
  
)

export default component.exports